"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CaretIcon;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function CaretIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "10px",
    height: "5px",
    viewBox: "0 0 10 5",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Formulary",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Export",
    transform: "translate(-1260.000000, -33.000000)",
    fill: "#000000"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Actions",
    transform: "translate(93.000000, 23.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Navigation-/-Caret",
    transform: "translate(1160.000000, 0.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "ic_arrow_drop_down"
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Icon",
    points: "7 10 12 15 17 10"
  })))))));
}